<div [@myAnimation]="show" *ngIf="show"
    style="top: 0; left: 0; bottom: 0; right: 0; position: fixed; overflow: hidden; z-index: 1000;">
    <div class="confetti-anchor z-depth-4">
        <div class="confetti-modal ">
            <h5>Bravo</h5>
            <i class="far fa-grin-beam fa-4x green-text" #confettiDiv></i>
        </div>
    </div>
</div>